import { Component, OnInit, ViewChild, ElementRef, HostListener, Input, OnChanges } from '@angular/core';
import * as _ from 'lodash';
import * as echarts from 'echarts';
import { StatistiqueModel, CoreService, HttpService, StatistiqueDetailNoteChapitreEL, QResult } from 'projects/lib-components/src/public_api';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-BarDetailNote',
  templateUrl: './BarDetailNoteChapitre.component.html',
  styleUrls: ['./BarDetailNoteChapitre.component.css']
})

export class BarDetailNoteComponent implements OnInit, OnChanges {
  @ViewChild('graphtest', { static: false }) graphtest: ElementRef;
  myChart: any;
  DetailNoteChapitreEL: StatistiqueDetailNoteChapitreEL = new StatistiqueDetailNoteChapitreEL();


  @Input('IdChapitre') IdChapitre: number;
  @Input('IdCycle') IdCycle: number;
  @Input('IdApprenant') IdApprenant: number;

  constructor(
    protected IndParam: CoreService,
    protected http: HttpService
  ) { }

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    if (window.innerWidth < 900) {
      this.myChart._model.option.xAxis[0].axisLabel.rotate = 50;
    } else {
      this.myChart._model.option.xAxis[0].axisLabel.rotate = 0;
    }

    if (this.DetailNoteChapitreEL.ListModule && this.DetailNoteChapitreEL.ListModule.length > 0) {
      this.myChart.resize();
    }
  }

  ngOnInit(): void { }

  ngOnChanges(): void {

    const style: CSSStyleDeclaration = getComputedStyle(document.body);
    const Cmain: string = style.getPropertyValue('--c-main');
    const Csecondary: string = style.getPropertyValue('--c-secondary');
    const clightmain: string = style.getPropertyValue('--c-light-main');
    const cdarkmain: string = style.getPropertyValue('--c-dark-main');


    this.http.getHttp<QResult<StatistiqueModel>>(`${this.IndParam.AppParams.apiUrl}api/statistique/el/GraphDetailNoteChapitre/${this.IdCycle}|${this.IdChapitre}|${this.IdApprenant}`).subscribe((result: QResult<StatistiqueModel>) => {
      if (!result.HasError) {
        this.DetailNoteChapitreEL = result.Value.StatElearning.DetailNoteChapitreEL;

        setTimeout(() => {
          if (this.DetailNoteChapitreEL.ListModule.length > 0) {
            this.myChart = echarts.init(this.graphtest.nativeElement);
            this.myChart.setOption({
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'shadow'
                },
                formatter: function (params: any) {
                  let res = '';
                  const colorSpan = (color: string) => '<span style="display:inline-block;margin-right:5px;borderradius:10px;width:9px;height:9px;background-color:' + color + '"></span>' ;
                  const idMoy = params.indexOf(params.find((element: any) => element.seriesName === 'Moyenne de l\'enseignement'));
                  const idApp = params.indexOf(params.find((element: any) => element.seriesName === 'Note de l\'apprenant'));
                  const idNoteMin = params.indexOf(params.find((element: any) => element.seriesName === 'notemin'));
                  const idNoteMax = params.indexOf(params.find((element: any) => element.seriesName === 'Ecart type'));

                  if (idMoy !== -1) {
                    res += '<br/>' + colorSpan(params[idMoy].color) + ' Moyenne de l\'enseignement: ' + params[idMoy].name;
                  }
                  if (idApp !== -1) {
                    res += '<br/>' + colorSpan(params[idApp].color) + ' Note de l\'apprenant: ' + params[idApp].name;
                  }
                  if (idNoteMax !== -1) {
                    const minNote = params[idNoteMin].name;
                    const maxNote = Number(params[idNoteMin].name) + Number(params[idNoteMax].name);
                    res += '<br/>' + colorSpan(params[idNoteMax].color) + ' Note Minimal: ' + minNote + ' Note Maximal: ' + maxNote;
                  }
                  return res;
                }
              },
              legend: {
                data: ['Ecart type', 'Note de l\'apprenant', 'Moyenne de l\'enseignement']
              },
              grid: {
                left: '0%',
                right: '4%',
                bottom: '3%',
                containLabel: true
              },
              xAxis: {
                type: 'category',
                data: this.DetailNoteChapitreEL.ListModule,

                axisLabel: {
                  interval: 0,
                  formatter: function (value: string, index: number) {
                    if (value.length > 10) {
                      value = value.substring(0, 10) + '...';
                    }
                    return value;
                  }
                }
              },
              yAxis: {
                type: 'value',
                min: 0,
                max: 100,
                axisLabel: {
                  formatter: '{value} %'
                }
              },
              series: [
                {
                  name: 'Note de l\'apprenant',
                  type: 'line',
                  itemStyle: {
                    normal: {
                      barBorderColor: 'rgba(0,0,0,0)',
                      color: clightmain,
                      borderColor: cdarkmain,
                      borderWidth: 5
                    },
                  },
                  lineStyle: {
                    normal: {
                      width: 3,
                      shadowColor: 'rgba(0,0,0,0.4)',
                      shadowBlur: 10,
                      shadowOffsetY: 10
                    }
                  },
                  label: {
                    show: true,
                    position: 'top',
                    formatter: '{b}',
                    textStyle: {
                      color: clightmain,
                      fontSize: 18,
                      fontWeight: 'bold'
                    }
                  },
                  markLine: {
                    data: [
                      { type: 'average', name: 'Moyenne general de l\'eleve' }
                    ]
                  },
                  data: this.DetailNoteChapitreEL.ListNoteApprenant,
                },
                {
                  name: 'Moyenne de l\'enseignement',
                  type: 'line',
                  itemStyle: {
                    normal: {
                      barBorderColor: 'rgba(0,0,0,0)',
                      color: Csecondary
                    },
                  },
                  lineStyle: {
                    normal: {
                      width: 3,
                      shadowColor: 'rgba(0,0,0,0.4)',
                      shadowBlur: 10,
                      shadowOffsetY: 10
                    }
                  },
                  label: {
                    show: true,
                    position: 'top',
                    formatter: '{b}',
                    textStyle: {
                      color: Csecondary,
                      fontSize: 18,
                      fontWeight: 'bold'
                    }
                  },
                  data: this.DetailNoteChapitreEL.ListMoyNoteChapitre,
                },
                {
                  name: 'notemin',
                  type: 'bar',
                  stack: true,
                  itemStyle: {
                    normal: {
                      barBorderColor: 'rgba(0,0,0,0)',
                      color: 'rgba(0,0,0,0)'
                    },
                    emphasis: {
                      barBorderColor: 'rgba(0,0,0,0)',
                      color: 'rgba(0,0,0,0)'
                    }
                  },
                  data: this.DetailNoteChapitreEL.ListNoteMin,
                },
                {
                  name: 'Ecart type',
                  type: 'bar',
                  stack: true,
                  labelLine: {
                    normal: {
                      show: false
                    }
                  },
                  itemStyle: {
                    normal: {
                      color: Cmain,
                      borderWidth: 3,
                      borderColor: '#ffffff',
                    },
                    emphasis: {
                      borderWidth: 3,
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                  },
                  data: this.DetailNoteChapitreEL.ListNoteEcart,
                },

              ]
            });
          }
        }, 1);
      }
    });
  }
}



